export default __webpack_public_path__ + "static/media/olx-logo.b3f099a2.png";